import utils from "../common/libs/utils";

const baseUrl = "/website/api/";
//const commonUrl="/api/";

export default {
    //获取网站设置
    getSetting(params={}){
        return new Promise((resolve)=>{
            utils.get('setting/get',params).then(data=>{
                resolve(data)
            })
        })
    },
    //获取栏目列表
    getNavList(params={}){
        return new Promise((resolve)=>{
            utils.get('nav_column/list',params).then(data=>{
                resolve(data)
            })
        })
    },
    //1.获取职位列表
    getJobsList(params = {}) {
        return new Promise((resolve) => {
            utils.get('job/page', params).then(data => {
                resolve(data);
            })
        });
    },
    //获取双选会列表
    getJobFairList(params = {}) {
        return new Promise((resolve) => {
            utils.get('bothmeet/page', params).then(data => {
                resolve(data);
            })
        });
    },
    //获取近期双选会列表
    getRecentJobFairList(params = {}) {
        return new Promise((resolve) => {
            utils.get('bothmeet/get_recent_bothmeet_list', params).then(data => {
                resolve(data);
            })
        });
    },
    //获取宣讲会列表
    getCareerList(params = {}) {
        return new Promise((resolve) => {
            utils.get('career/page', params).then(data => {
                resolve(data);
            })
        });
    },
    //获取新闻资讯
    getNoticeList(params = {}) {
        return new Promise(resolve => {
            utils.get('news/page', params).then(data => {
                resolve(data);
            })
        })
    },
    //获取公司列表
    getCompanyList(params = {}) {
        return new Promise(resolve => {
            utils.get('bothmeet/get_job_page', params).then(data => {
                resolve(data);
            })
        })
    },
    //就业报告
    getReportList(params = {}) {
        return new Promise(resolve => {
            utils.get(baseUrl + 'get_month_event_day', params).then(data => {
                resolve(data);
            })
        })
    },
    //获取日历招聘会
    getMothEventDay(params = {}) {
        return new Promise(resolve => {
            utils.get('home/get_calendar_day', params).then(data => {
                resolve(data);
            })
        })
    },
    //获取首页信息
    getHomeData(params = {}) {
        return new Promise(resolve => {
            utils.get('home/get_data', params).then(data => {
                resolve(data);
            })
        })
    },


    //获取职位详情
    getJobDetail(params = {}) {
        return new Promise(resolve => {
            utils.get('job/get', params).then(data => {
                resolve(data);
            })
        })
    },
    //获取双选会详情
    getJobfairDetail(params = {}) {
        return new Promise(resolve => {
            utils.get('bothmeet/get', params).then(data => {
                resolve(data);
            })
        })
    },
    //获取宣讲会详情
    getCareerDetail(params = {}) {
        return new Promise(resolve => {
            utils.get('career/get', params).then(data => {
                resolve(data);
            })
        })
    },
    //获取通知详情
    getNoticeDetail(params = {}) {
        return new Promise(resolve => {
            utils.get('news/get', params).then(data => {
                resolve(data);
            })
        })
    },
    //获取职位发布院校
    getPublishSchoolList(params = {}) {
        return new Promise(resolve => {
            utils.get('job/get_publish_school_list', params).then(data => {
                resolve(data);
            })
        })
    },
    //获取公司详情
    getCompanyDetail(params = {}) {
        return new Promise(resolve => {
            utils.get('company/get', params).then(data => {
                resolve(data);
            })
        })
    },
    //根据双选会申请Id获取公司详情
    getCompanyDetailByBothmeetApplyId(params={}){
        return new Promise(resolve=>{
            utils.get('bothmeet/get_company_info_by_apply_id',params).then(data=>{
                resolve(data);
            })
        })
    },
    getDictList(params = {}) {
        return new Promise(resolve => {
            utils.get('sys_dict_data/get_dict_data_dropdown', params).then(data => {
                resolve(data);
            })
        })
    },
    getCalendar(params = {}) {
        return new Promise(resolve => {
            utils.get('home/get_calendar', params).then(data => {
                resolve(data);
            })
        })
    },
    getSchoolList(params = {}) {
        return new Promise(resolve => {
            utils.get('school/list', params).then(data => {
                resolve(data);
            })
        })
    }
};


